import React from 'react';
import Hero from '../components/Hero';
import Announcement from '../components/Announcement';
import Services from '../components/Services';
import Methodology from '../components/Methodology';
import CTA from '../components/CTA';

const Home = () => {
  return (
    <>
      <Hero />
      <Announcement />
      <Services />
      <Methodology />
      <CTA />
    </>
  );
};

export default Home;
